import React from "react";

/**
 * TrustStrip — thin, high-contrast strip that surfaces the site's strongest
 * trust ingredients right under the hero. Conversion ammunition, per the audit.
 */
export default function TrustStrip() {
  const items = [
    "No credit card",
    "120 free credits",
    "Credits never expire",
    "Commercial rights",
    "Cancel anytime",
  ];
  return (
    <div className="border-y border-border bg-background" data-testid="trust-strip">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-4 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-[10px] md:text-xs font-mono uppercase tracking-widest text-muted-foreground">
        {items.map((it, i) => (
          <span key={it} className="flex items-center gap-6">
            {i > 0 && <span className="opacity-40">·</span>}
            <span>{it}</span>
          </span>
        ))}
      </div>
    </div>
  );
}
